import { render, staticRenderFns } from "./register-company.vue?vue&type=template&id=370d4b39"
import script from "./register-company.vue?vue&type=script&lang=js"
export * from "./register-company.vue?vue&type=script&lang=js"
import style0 from "./register-company.vue?vue&type=style&index=0&id=370d4b39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports